function LayoutSkeleton() {
  return (
    <div className="flex flex-col gap-3 w-full bg-gray-200 dark:bg-gray-800 animate-pulse p-4 rounded-xl">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center w-11/12 gap-4">
          <div className="rounded-full size-16 bg-gray-300 dark:bg-gray-600"></div>
          <div className="flex w-full gap-2 flex-col">
            <div className="w-3/4 h-4 rounded-md bg-gray-300 dark:bg-gray-600"></div>
            <div className="w-1/6 h-2 rounded-sm bg-gray-300 dark:bg-gray-600"></div>
          </div>
        </div>
        <div className="w-1/12 h-4 rounded-md bg-gray-300 dark:bg-gray-600"></div>
      </div>
    </div>
  );
}

export default LayoutSkeleton;
